import axios from '../../../axios';
import ICWJobsJobPostDTO from '../types/ICWJobsJobPostDTO';

const url = '/jobsearch/api/cw-jobs/';
const totalJobsLocationsUrl = '/jobsearch/api/total_jobs_locations/';

export const postToCWJobs = (payload: ICWJobsJobPostDTO) => axios.post(`${url}publish`, payload);

export const deleteJobFromCWJobs = (payload: ICWJobsJobPostDTO) =>
  axios.post(`${url}delete`, payload);

export const getCWJobsLocations = (query: string) =>
  axios.get(`${totalJobsLocationsUrl}search?query=${query}`);
